export default "/images/3d5051a1ec744e0b008c9264149a7bcd.avif";